import { authenticationGuard } from '@/auth/authenticationGuard'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'home',
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/Profile.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/incident-list',
    name: 'incident-list',
    component: () => import('@/views/Custom Widgets/IncidentList.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/user-incident-list',
    name: 'user-incident-list',
    component: () => import('@/views/Custom Widgets/UserIncidentList.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/user-incident-detail/:id',
    name: 'user-incident-detail',
    component: () => import('@/views/Custom Widgets/UserIncidentDetails.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/incident-detail/:id',
    name: 'incident-detail',
    component: () => import('@/views/Custom Widgets/IncidentDetails.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/trainings',
    name: 'trainings',
    component: () => import('@/views/Tabs/Trainings.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/users',
    name: 'user-information',
    component: () => import('@/views/Tabs/UserInformation.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/oracle',
    name: 'oracle',
    component: () => import('@/views/Tabs/Oracle.vue'),
    meta: {
      layout: 'content',
    },
    beforeEnter: authenticationGuard,
  },
  {
    path: '/second-page',
    name: 'second-page',
    component: () => import('@/views/Tabs/SecondPage.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/third-page',
    name: 'third-page',
    component: () => import('@/views/Tabs/ThirdPage.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/trends',
    name: 'trends',
    component: () => import('@/views/Tabs/Trends.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
